import { useAtom } from "jotai";

import distanceFilterAtom from "../jotai/atoms/distanceFilterAtom";

const useDistanceFilter = () => {
  const [distanceFilter, setDistanceFilter] = useAtom(distanceFilterAtom);

  return { distanceFilter, setDistanceFilter };
};

export default useDistanceFilter;
